<template>
    <EditWindow heading="Edit group" :name="group_name" @close="emit('close')">

        <EditSection title="Class">
            <EditField :object="group" field="subject" label="Subject" :suggestions="subjects"/>
            <EditField :object="group" field="duration" label="Duration (hours)" type="number" step="0.25"
                       hint="Length of each class. Classes take it when the teacher confirms them, and pay and package hours count from it."/>
            <EditField :object="group" field="is_active" label="Active" type="checkbox"/>
            <EditField :object="group" field="schedule" label="Schedule" wide :check="schedule_warning"
                       hint="Days, then start and end time: MO WE 18:00 19:00. Separate different times with |, e.g. MO 12:00 13:00 | TH 11:00 12:00."/>
        </EditSection>

        <EditSection title="Links">
            <EditField :object="group" field="link" label="Class link" :href="web_link" wide
                       hint="Takes priority over the teacher's own class link."/>
            <EditField :object="group" field="whatsapp" label="WhatsApp group" :href="web_link" wide/>
        </EditSection>

        <EditSection title="Pay">
            <EditField :object="group" field="hourly_rate" label="Group hourly rate (MXN)" type="number" step="0.01"
                       hint="0 = the teacher is paid their own rate. Any other amount replaces it for this group's classes."/>
        </EditSection>

        <EditSection title="People & materials"
                     note="Read-only here. Students are managed from the group's row, teachers from the teacher's row.">
            <EditField :object="group" field="instructor" label="Teachers" readonly :display="names"/>
            <EditField :object="group" field="student" label="Students" readonly :display="names"/>
            <EditField :object="group" field="material" label="Materials" readonly :display="names"/>
        </EditSection>

        <EditSection title="Notes">
            <EditField :object="group" field="comments" label="Comments" type="textarea"/>
        </EditSection>

    </EditWindow>
</template>


<script setup>

    import {ref,computed,onMounted} from 'vue'
    import EditWindow from '@/components/edit/EditWindow.vue'
    import EditSection from '@/components/edit/EditSection.vue'
    import EditField from '@/components/edit/EditField.vue'
    import {load_options,web_link} from '@/components/edit/helpers.js'

    const props=defineProps({
        group:{type:Object,required:true},
    })
    const emit=defineEmits(['close'])

    const day_codes=['MO','TU','WE','TH','FR','SA','SU']

    let subjects=ref([])

    let group_name=computed(()=>[props.group.subject,props.group.schedule].filter(Boolean).join(' · ') || 'Group')

    onMounted(async()=>{
        let options=await load_options()
        subjects.value=options.observed['Group.subject'] || []
    })

    function names(rows){
        return (rows || []).map(row=>row.ui || row.name).filter(Boolean).join(', ') || '—'
    }

    // Mirrors Schedule in operation/custom_functions.py, which the availability grid runs on
    // every entry: one without two H:MM times crashes it, one without a day code is skipped.
    function schedule_warning(schedule){
        if(schedule===''){
            return ''
        }
        let readable_time=time=>/^\d{1,2}:\d{2}$/.test(time)
        let unreadable=String(schedule).split('|').filter(entry=>{
            let parts=entry.split(' ')
            let times=parts.filter(part=>part.includes(':'))
            return !parts.some(part=>day_codes.includes(part))
                || times.length<2 || !readable_time(times[0]) || !readable_time(times[1])
        })
        if(!unreadable.length){
            return ''
        }
        return `The availability grid can't read ${unreadable.map(entry=>`"${entry.trim()}"`).join(', ')}.`
    }

</script>
